<template>
	<div class="jointly">
		<HNB></HNB>
		<div class="jointly-title">跨界联名产品</div>
		<div class="jointly-Main">
			<div v-for="(itme,num) in jointlyAry">
				<div class="jointly-Main-title">{{itme.title}}</div>
				<div class="jointly-Main-write">{{itme.write}}</div>
				<div class="jointly-Main-imgAry" >
					<div class="jointly-Main-imgAry-view" :style="itme.imgAry.length < 3  ? 'margin: 0 auto;':''" v-for="imgItme in itme.imgAry">
						<div class="jointly-Main-imgAry-img"><img :src="imgItme.img"/></div>
						<div class="jointly-Main-imgAry-name" v-html="imgItme.name">{{imgItme.name}}</div>
					</div>
				</div>
				<div class="jointly-Main-bottom" v-show="num != (jointlyAry.length - 1)"></div>
			</div>
		</div>
		<div style="width: 100%; height: 5.875rem;"></div>
		<Bottom :BsTitle="bsTitle"></Bottom>
	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import Bottom from '../components/Bottom.vue'
	
	export default{
		name:'jointly',
		
		components:{
			HNB,
			Bottom
		},
		data(){
			return{
				bsTitle:['首页', '跨界联名产品'],
			}
		},
		computed:{
			jointlyAry(){
				let jointlyAry = [{
					title:'乐范 × 熊本熊',
					write:'每天按摩15分钟，元气能量嘭起来。萌、呆、潮、贱，把熊本熊魔力按摩贴带回家撒欢，让它治愈你的疲惫吧！ ',
					imgAry:[{
						img:this.GLOBAL.imgHost + '/images/jointproduct/bear1.png',
						name:'酷炫魔力按摩贴</br>熊本熊黑',
					},{
						img:this.GLOBAL.imgHost + '/images/jointproduct/bear2.png',
						name:'酷炫魔力按摩贴</br>萌力白',
					}],
				},
				{
					title:'乐范 × 迪士尼',
					write:'我们想给大家带来亲切熟悉又新鲜有趣的体验，忙碌的生活中既能愉快的放松身体，也能激发儿时的动画情怀，于是迪士尼联名款魔力按摩贴应',
					imgAry:[{
						img:this.GLOBAL.imgHost + '/images/jointproduct/Disney1.png',
						name:'米奇出没</br>妙趣横生',
					},{
						img:this.GLOBAL.imgHost + '/images/jointproduct/Disney2.png',
						name:'时尚米妮</br>童心童趣',
					},],
				},
				{
					title:'乐范 × 得到',
					write:'得到，用互联网思维去读书，提供碎片化学习方式。而乐范，为高压生活环境下的年轻人提供碎片化的轻松方式，让按摩变得简单。 ',
					imgAry:[{
						img:this.GLOBAL.imgHost + '/images/jointproduct/dedao1.png',
						name:'得到定制炫酷版魔力贴</br>几何系列',
					},{
						img:this.GLOBAL.imgHost + '/images/jointproduct/dedao2.png',
						name:'得到定制温情版魔力贴</br>双生鹰系列',
					},{
						img:this.GLOBAL.imgHost + '/images/jointproduct/dedao3.png',
						name:'得到特别定制版石墨烯加热眼罩 </br>”吃饭叫我”系列',
					},],
				},
				{
					title:'乐范 × 吴晓波频道',
					write:'把吴晓波的书名《把生命浪费在美好的事物上》印在乐范石墨烯加热眼罩上，温润冷眼世情。 ',
					imgAry:[{
						img:this.GLOBAL.imgHost + '/images/jointproduct/wuxiaobo1.png',
						name:'特别定制版',
					},{
						img:this.GLOBAL.imgHost + '/images/jointproduct/wuxiaobo2.png',
						name:'特别定制版',
					},{
						img:this.GLOBAL.imgHost + '/images/jointproduct/wuxiaobo3.png',
						name:'特别定制版',
					},],
				},
				{
					title:'乐范 × 日行千里',
					write:'动感气囊，对小腿进行有节奏的按摩，促进肌肉酸胀，让奔波忙碌的双腿得到轻松释放。',
					imgAry:[{
						img:this.GLOBAL.imgHost + '/images/jointproduct/xingzou.png',
						name:'脚部气压按摩器</br>日行千里系列',
					}],
				},]
				
				return jointlyAry;
			}
			
		}
	}
	
</script>

<style>
	.jointly {
		margin: 0 auto;
		max-width: 33.67rem;
	}
	
	.jointly-title {
		width: 100%;
		font-size: 1.8rem;
		font-weight: 400;
		color: #1D1D1D;
		font-family: "Alibaba-PuHuiTi-R";
		margin-top: 2.25rem;
	}
	
	.jointly-Main .jointly-Main-title{
		font-weight: 500;
		padding-top: 2.75rem;
		color:rgba(23,23,23,1);
		font-size: 0.925rem;
		font-family: "Alibaba-PuHuiTi-M";
	}
	
	.jointly-Main .jointly-Main-write{
		font-weight: 400;
		padding-top: 1.35rem;
		width: 90%;
		margin-left: 5%;
		color:rgba(23,23,23,1);
		font-size: 0.125rem;
		font-family: "Alibaba-PuHuiTi-R";
	}
	
	.jointly-Main .jointly-Main-imgAry{
		width: 100%;
		display: flex;
		flex-direction: row;
		overflow: scroll;
		margin-top: 2.875rem;
		margin-bottom: 1rem;
	}
	
	.jointly-Main .jointly-Main-imgAry .jointly-Main-imgAry-view{
		margin-left: 5%;
	}
	
	.jointly-Main .jointly-Main-imgAry .jointly-Main-imgAry-img{
		width: 9.75rem;
		background-color: rgba(238,238,238,1);
		height: 9.75rem;
	}
	
	.jointly-Main .jointly-Main-imgAry .jointly-Main-imgAry-img img{
		width: 80%;
		height: 80%;
		margin: 10% auto;
	}
	
	.jointly-Main .jointly-Main-imgAry .jointly-Main-imgAry-name{
		width: 80%;
		margin: 0 auto;
		margin-top: 1rem;
		font-size: 0.625rem;
	}
	
	.jointly-Main .jointly-Main-bottom{
		height: 1px;
		width: 95%;
		margin-left: 5%;
		background-color: rgba(229,229,229,1);
	}
	
</style>
